export default {
  DEFAULT_SELECTED_DATE_RANGE: 10,
  MAX_DATE_RANGE_LIMIT: 90,
  STATIC_DATE_RANGES: [
    { label: 'Last 7 Days', value: 7 },
    { label: 'Last 14 Days', value: 14 }
  ],
  chartColors: {
    orange: '#DB5B0C'
  }
};
